interface MalariaRiskProps {
  destination: any;
}

export default function MalariaRisk({ destination }: MalariaRiskProps) {
  const healthRecommendations = destination?.health_recommendations;

  if (!healthRecommendations?.malaria_risk?.present) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "16px",
        marginBottom: "16px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#dc2626"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <h3
          style={{
            fontSize: "16px",
            fontWeight: "600",
            color: "#111827",
            margin: 0,
          }}
        >
          Malaria Risk
        </h3>
      </div>

      <div
        style={{
          backgroundColor: "#fef2f2",
          padding: "16px",
          borderRadius: "8px",
          marginBottom: "16px",
        }}
      >
        <p
          style={{
            fontSize: "14px",
            color: "#991b1b",
            marginBottom: "8px",
            fontWeight: "600",
          }}
        >
          Malaria risk is present in this destination.
        </p>
        {healthRecommendations.malaria_risk.prophylaxis_recommended && (
          <p
            style={{
              fontSize: "14px",
              color: "#b91c1c",
              marginBottom: "12px",
            }}
          >
            Prophylaxis medication is recommended.
          </p>
        )}

        {healthRecommendations.malaria_risk.details && (
          <div
            style={{
              fontSize: "14px",
              color: "#b91c1c",
              lineHeight: "1.6",
            }}
          >
            <p style={{ whiteSpace: "pre-line", margin: 0 }}>
              {healthRecommendations.malaria_risk.details}
            </p>
          </div>
        )}
      </div>

      {healthRecommendations.malaria_risk.prophylaxis_drugs &&
        healthRecommendations.malaria_risk.prophylaxis_drugs.length > 0 && (
          <div style={{ marginBottom: "16px" }}>
            <h5
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#111827",
                marginBottom: "12px",
              }}
            >
              Recommended Prophylaxis Options:
            </h5>
            <div
              className="grid grid-cols-1 sm:grid-cols-2"
              style={{
                gap: "8px",
              }}
            >
              {healthRecommendations.malaria_risk.prophylaxis_drugs.map(
                (drug: string, index: number) => (
                  <div
                    key={index}
                    style={{
                      fontSize: "12px",
                      padding: "8px",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      textAlign: "center",
                      backgroundColor: "white",
                    }}
                  >
                    {drug}
                  </div>
                )
              )}
            </div>
          </div>
        )}

      <p
        style={{
          fontSize: "12px",
          color: "#6b7280",
          margin: 0,
        }}
      >
        Consult with a healthcare provider to determine the best prophylaxis
        option for you and to discuss timing of medication.
      </p>
    </div>
  );
}
